import { useGetAllProjectSections } from './useGetAllProjectSections';
import { useState, useEffect } from 'react';
import { ISection } from '@/api/projects/types';
import { getAllProjectSections } from '@/api/projects/getAllProjectSections';

export const useProjectSections = (projectId: string, initialSectionId?: string) => {
  const [sections, setSections] = useState<ISection[]>([]);
  const [selectedSection, setSelectedSection] = useState<ISection | null>(null);
  const { data: sectionsData, refetch: refetchSections } = useGetAllProjectSections(Number(projectId));

  useEffect(() => {
    if (sectionsData?.data) {
      setSections(sectionsData.data);
      // Si hay un initialSectionId, seleccionar esa sección
      if (initialSectionId) {
        const section = sectionsData.data.find((s: ISection) => String(s.id) === initialSectionId);
        if (section) {
          setSelectedSection(section);
        }
      } else if (sectionsData.data.length > 0 && !selectedSection) {
        // Si no hay sección seleccionada, seleccionar la primera
        setSelectedSection(sectionsData.data[0]);
      }
    }
  }, [sectionsData, initialSectionId, selectedSection]);

  const updateSections = async (newProjectId: string) => {
    try {
      const newSections = await getAllProjectSections(Number(newProjectId));
      
      if (!newSections?.data?.length) {
        throw new Error("El proyecto seleccionado no tiene secciones disponibles");
      }

      setSections(newSections.data);
      setSelectedSection(newSections.data[0]);
      return newSections.data[0];
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error("Error al obtener las secciones del proyecto");
    }
  };

  return {
    sections,
    selectedSection,
    setSelectedSection,
    updateSections,
    refetchSections
  };
}; 